import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import ReactSpinner from "react-spinjs-fix";

import Show from "../widgets/Show";
import FilledImage from "../widgets/FilledImage";

import bindActions from "../../helpers/bindActions";
import * as remindersActions from "../../actions/remindersActions";
import MenuImage from "../../assets/images/chart/find_apptMenuIcon@2x.png";

const enhancer = connect(null, bindActions({ remindersActions }));
class RemindersTogglePatientAll extends React.Component {
  componentDidMount() {
    this.props.remindersActions.initPatientList();
  }

  loadList = (e) => {
    const scrollBottom = e.target.scrollTop + e.target.offsetHeight + 1 >= e.target.scrollHeight;

    if (scrollBottom) {
      this.props.remindersActions.loadPatientList();
    }
  };

  render() {
    const { fetchingPatientList, patientList, searchPatient, togglePatientSelected } = this.props;

    let list = [];

    _.forEach(patientList, (value, index) => {
      list.push(
        <div
          className="list-group-item"
          key={index}
          onClick={() => {
            this.props.remindersActions.togglePatient(
              false,
              value.id,
              false,
              value.companyPatientId || value.companyTempPatientId,
            );
          }}
        >
          <div className="text">{value.fullname}</div>
          <Show if={!_.isEmpty(togglePatientSelected[value.id])}>
            <div className="arrow">✔</div>
          </Show>
        </div>,
      );
    });

    return (
      <div>
        <div className="input-group search">
          <span className="input-group-addon">
            <FilledImage color={"#aaa"} src={MenuImage} className="zoom-2-5x" />
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="search"
            value={searchPatient}
            onChange={this.props.remindersActions.searchPatient}
          />
        </div>
        <div className="list-group" onScroll={this.loadList}>
          {list}
          <Show if={fetchingPatientList}>
            <ReactSpinner />
          </Show>
        </div>
      </div>
    );
  }
}
export default enhancer(RemindersTogglePatientAll);
